import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeader } from "@/components/Reveal";

const FAQS = [
  {
    q: "What does the 360° offer include?",
    a: "Three production types, custom-made for your company: 360° room tours for immersive property walkthroughs, drone flights for stunning aerial footage, and classic promo clips for ads and social media. You pick the mix each month.",
  },
  {
    q: "Can I request unlimited revisions?",
    a: "Yes — unlimited revisions during your first month so we nail your style. After that, each production includes 2 revision rounds, which covers 95% of requests.",
  },
  {
    q: "How do you tailor content to my company?",
    a: "You upload your photos, brand assets, and market data once. We learn your voice and visual style, then produce on-brand tours, flights, and clips for every listing.",
  },
  {
    q: "What happens if I cancel?",
    a: "Nothing dramatic. No penalties, no exit fees — billing is monthly. And every production we ever made for you stays yours forever.",
  },
  {
    q: "Is the content royalty-free?",
    a: "100% yes. You get full commercial rights to every room tour, drone flight, and clip — across every platform, in perpetuity.",
  },
  {
    q: "What languages do you support?",
    a: "English today (US, UK, Canada, Australia). Spanish and German launch in Q4 2026.",
  },
];

export const Faq = () => (
  <section id="faq" className="bg-white py-24 sm:py-32" data-testid="faq-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        chapter="05 — Answers"
        title="Frequently Asked Questions"
      />

      <Reveal className="mx-auto max-w-3xl">
        <Accordion type="single" collapsible data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem key={item.q} value={`item-${i}`} className="border-b-2 border-hero-black/10">
              <AccordionTrigger
                className="py-6 text-left font-display text-lg font-semibold uppercase tracking-wide text-hero-black hover:text-hero-blue hover:no-underline sm:text-xl"
                data-testid={`faq-trigger-${i + 1}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-hero-black/70" data-testid={`faq-content-${i + 1}`}>
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
